<template>
  <div>
    <v-container
      fluid
      :class="almost_mobile ? 'pt-16 stycard' : 'pt-16 px-10 stycard'"
      style="min-height: 100vh"
    >
      <h3 class="pb-2 pt-3 pl-2" style="color: #00a99d; font-size: 25px">
        เวชระเบียน
      </h3>
      <div style="margin-top: 30px"></div>
      <v-row class="ml-1">
        <v-col cols="12" sm="12" md="4" lg="4" xl="4" class="card-search mb-5">
          <v-text-field
            v-model="search"
            class="card-search"
            label="ค้นหา"
            dense
            solo
            hide-details
            append-icon="mdi-magnify"
            clearable
          ></v-text-field>
        </v-col>
        <v-spacer></v-spacer>
        <v-col cols="6" sm="12" md="3" lg="2" xl="2" class="mb-5">
          <v-btn color="#00a99d" dark @click="addPatient()" class="card-search"
            ><v-icon class="mr-2">mdi-plus-circle</v-icon
            >ลงทะเบียนผู้ป่วย</v-btn
          >
        </v-col>
      </v-row>
      <v-data-table
        :headers="headers"
        :items="patientList"
        @click:row="patientOpen"
        hide-default-footer
      >
        <template v-slot:item.no="{ item }">
          <span class="font-16">{{ page > 1 ? ((page-1) * 10) + patientList.indexOf(item) + 1 : patientList.indexOf(item) + 1 }}</span>
        </template>
        <template v-slot:item.name="{ item }">
          <span class="font-16"
            >{{ item.account_title_th }} {{ item.first_name_th }}
            {{ item.last_name_th }}
          </span>
        </template>
        <template v-slot:item.gender="{ item }">
          <span class="font-16">{{ displayItem(item, "gender") }}</span>
        </template>
        <template v-slot:item.old="{ item }">
          <span class="font-16">{{ displayItem(item, "old") }}</span>
        </template>
        <template v-slot:item.phone="{ item }">
          <span class="font-16">{{ displayItem(item, "phone") }}</span>
        </template>
        <template v-slot:item.actions="{ item }">
          <div class="d-flex justify-center py-2">
            <!-- <v-tooltip bottom>
              <template v-slot:activator="{ on }">
                <div v-on="on">
                  <v-btn
                    class="mx-1"
                    color="#00a99d"
                    icon
                    @click="patientOpen(item)"
                  >
                    <v-icon color="#00a99d"
                      >mdi-account-box-outline</v-icon
                    >
                  </v-btn>
                </div>
              </template>
              <span>ข้อมูลผู้ป่วย</span>
              </v-tooltip> -->
            <v-tooltip bottom v-if="!item.healthcheck_status">
              <template v-slot:activator="{ on }">
                <div v-on="on">
                  <v-btn
                    class="mx-1"
                    color="#00a99d"
                    icon
                    @click.stop="healthOpen(item)"
                  >
                    <v-icon color="#00a99d">mdi-file-document</v-icon>
                  </v-btn>
                </div>
              </template>
              <span>ผลตรวจสุขภาพประจำปี</span>
            </v-tooltip>

            <v-tooltip bottom>
              <template v-slot:activator="{ on }">
                <div v-on="on">
                  <v-btn
                    class="mx-1"
                    color="#00a99d"
                    icon
                    @click.stop="dianoticOpen(item)"
                  >
                    <v-icon color="#00a99d"
                      >mdi-clipboard-text-clock-outline</v-icon
                    >
                  </v-btn>
                </div>
              </template>
              <span>ประวัติการรักษา</span>
            </v-tooltip>

            <v-tooltip bottom>
              <template v-slot:activator="{ on }">
                <div v-on="on">
                  <v-btn
                    class="mx-1"
                    color="#00a99d"
                    icon
                    @click.stop="emrCall(item)"
                  >
                    <v-icon color="#00a99d">mdi-phone-outgoing</v-icon>
                  </v-btn>
                </div>
              </template>
              <span>EMR Call</span>
            </v-tooltip>
            <v-tooltip v-if="biz_id !== '1349242890488778'" bottom>
              <template v-slot:activator="{ on }">
                <div v-on="on">
                  <v-btn
                    class="mx-1"
                    color="#00a99d"
                    icon
                    @click.stop="findCIDOpen(item)"
                  >
                    <v-icon color="#00a99d">mdi-qrcode</v-icon>
                  </v-btn>
                </div>
              </template>
              <span>QR code</span>
            </v-tooltip>
            <!-- <v-tooltip bottom>
              <template v-slot:activator="{ on }">
                <div v-on="on">
                  <v-btn
                    class="mx-1"
                    color="#00a99d"
                    icon
                    @click="dashboardEditNurseDialog()"
                  >
                    <v-icon color="#00a99d">mdi-square-edit-outline</v-icon>
                  </v-btn>
                </div>
              </template>
              <span>แก้ไขข้อมูลผู้ป่วย</span>
            </v-tooltip> -->
            
          </div>
        </template>
      </v-data-table>
      <Pagination :totals="total" :isPage="page" @page="changePage" />

      <!--  -->
      <v-dialog v-model="dialog" persistent scrollable>
        <v-card>
          <v-card-title class="justify-space-between pa-4">
            <v-btn icon disabled small><v-icon>mdi-clear</v-icon></v-btn>
            <span style="font-size: 20px; color: #00a99d; font-weight: bold">{{
              formTitle
            }}</span>
            <v-btn icon color="#00a99d" @click="close()" small
              ><v-icon>mdi-close</v-icon></v-btn
            >
          </v-card-title>
          <HeaderUser
            v-show="formTitle == 'แก้ไขรายชื่อผู้ป่วย'"
            ref="HeaderUser"
          ></HeaderUser>
          <v-card-actions v-show="formTitle == 'แก้ไขรายชื่อผู้ป่วย'">
            <v-spacer></v-spacer>
            <v-btn class="mr-3" @click="edit = true" color="#00a99d" outlined
              >แก้ไขข้อมูลผู้ป่วย</v-btn
            >
            <!-- <v-btn
              v-if="edit"
              class="mr-3"
              @click="edit = false"
              color="#00a99d"
              outlined
              >ปิดการแก้ไขข้อมูล</v-btn
            > -->
          </v-card-actions>
          <v-card-text class="py-4">
            <v-form
              ref="form"
              @submit.prevent="save()"
              :disabled="!edit && isFormDisabled"
            >
              <v-expansion-panels flat v-model="panel" multiple>
                <v-expansion-panel :key="0">
                  <v-expansion-panel-header class="px-0">
                    <div class="d-flex align-center">
                      <span class="pr-5 text-007C92 w-500 font-18"
                        >ข้อมูลส่วนตัว</span
                      >
                      <v-divider></v-divider>
                    </div>
                  </v-expansion-panel-header>
                  <v-expansion-panel-content>
                    <v-row class="py-5">
                      <v-col cols="6" sm="3" lg="2" class="d-flex">
                        <div class="d-flex flex-column">
                          <span> เพศ<span class="red--text">*</span> </span>
                          <v-radio-group
                            v-model="items.gender"
                            row
                            dense
                            class="pa-0 mt-2"
                            :readonly="view"
                            @change="genderChange"
                          >
                            <v-radio
                              label="ชาย"
                              value="ชาย"
                              color="#39a09f"
                            ></v-radio>
                            <v-radio
                              label="หญิง"
                              value="หญิง"
                              color="#39a09f"
                            ></v-radio>
                          </v-radio-group>
                        </div>
                      </v-col>
                      <v-col cols="6" sm="3" lg="2" class="d-flex">
                        <div class="d-flex flex-column">
                          <span>
                            คำนำหน้า<span class="red--text">*</span>
                          </span>
                          <v-select
                            solo
                            @input="titleChange"
                            v-model="items.account_title_th"
                            :items="titleItems"
                            hide-details="auto"
                            dense
                          ></v-select>
                        </div>
                      </v-col>
                      <v-col cols="6" sm="3" lg="4">
                        <div class="d-flex flex-column">
                          <span>
                            ชื่อ (ภาษาไทย)<span class="red--text">*</span>
                          </span>
                          <v-text-field
                            solo
                            hide-details="auto"
                            dense
                            :readonly="view"
                            :rules="isEmpty"
                            v-model="items.first_name_th"
                          ></v-text-field>
                        </div>
                      </v-col>
                      <v-col cols="6" sm="3" lg="4">
                        <div class="d-flex flex-column">
                          <span>
                            นามสกุล (ภาษาไทย)<span class="red--text">*</span>
                          </span>
                          <v-text-field
                            solo
                            hide-details="auto"
                            dense
                            :readonly="view"
                            v-model="items.last_name_th"
                          ></v-text-field>
                        </div>
                      </v-col>
                      <v-col cols="6" sm="3" lg="4">
                        <div class="d-flex flex-column">
                          <span>
                            ชื่อ (ภาษาอังกฤษ)<span class="red--text">*</span>
                          </span>
                          <v-text-field
                            solo
                            hide-details="auto"
                            dense
                            :readonly="view"
                            v-model="items.first_name_eng"
                          ></v-text-field>
                        </div>
                      </v-col>
                      <v-col cols="6" sm="3" lg="4">
                        <div class="d-flex flex-column">
                          <span>
                            นามสกุล (ภาษาอังกฤษ)<span class="red--text">*</span>
                          </span>
                          <v-text-field
                            solo
                            hide-details="auto"
                            dense
                            :readonly="view"
                            v-model="items.last_name_eng"
                          ></v-text-field>
                        </div>
                      </v-col>
                      <v-col
                        cols="6"
                        sm="3"
                        lg="4"
                        class="px-3 d-flex flex-column"
                      >
                        <div>
                          <span> ประเภทบัตร </span>
                          <span>
                            {{ displayIdCard(items.id_card_type)
                            }}<span class="red--text">*</span>
                          </span>
                        </div>
                        <div class="d-flex">
                          <v-select
                            solo
                            hide-details="auto"
                            dense
                            :disabled="isFormDisabled"
                            v-model="items.id_card_type"
                            item-text="text"
                            item-value="value"
                            :items="itemType"
                            style="width: 40%"
                          ></v-select>
                          <v-text-field
                            solo
                            hide-details="auto"
                            dense
                            :disabled="isFormDisabled"
                            v-model="items.id_card_num"
                            :readonly="view"
                            style="width: 60%"
                          ></v-text-field>
                        </div>
                      </v-col>

                      <v-col cols="6" sm="3" lg="2" class="d-flex">
                        <div class="d-flex flex-column">
                          <span>
                            วัน / เดือน / ปีเกิด<span class="red--text">*</span>
                          </span>
                          <v-menu
                            :readonly="view"
                            ref="birth_date"
                            v-model="menubirth_date"
                            :close-on-content-click="false"
                            :return-value.sync="items.birth_date"
                            transition="scale-transition"
                            offset-y
                            min-width="auto"
                          >
                            <template v-slot:activator="{ on, attrs }">
                              <v-text-field
                                solo
                                dense
                                :value="formatBirthDate"
                                append-icon="mdi-calendar"
                                readonly
                                v-bind="attrs"
                                v-on="on"
                              ></v-text-field>
                            </template>
                            <v-date-picker
                              ref="picker"
                              v-model="items.birth_date"
                              no-title
                              scrollable
                              :readonly="view"
                              :max="yearmax"
                              locale="th"
                              @input="calculateAge(items.birth_date)"
                            >
                              <v-spacer></v-spacer>
                              <v-btn
                                text
                                color="primary"
                                @click="cancel_birth()"
                              >
                                Cancel
                              </v-btn>
                              <v-btn
                                text
                                color="primary"
                                @click="calculateAge(items.birth_date)"
                              >
                                OK
                              </v-btn>
                            </v-date-picker>
                          </v-menu>
                        </div>
                      </v-col>
                      <v-col cols="6" sm="3" lg="2" class="d-flex">
                        <div class="d-flex flex-column">
                          <span> อายุ</span>
                          <v-text-field
                            solo
                            hide-details="auto"
                            v-model="items.age"
                            dense
                          ></v-text-field>
                        </div>
                      </v-col>
                      <v-col cols="6" sm="3" lg="2" class="d-flex">
                        <div class="d-flex flex-column">
                          <span> หมู่เลือด </span>
                          <v-select
                            solo
                            :items="['A', 'B', 'O', 'AB']"
                            v-model="items.blood"
                            hide-details="auto"
                            dense
                            :readonly="view"
                          ></v-select>
                        </div>
                      </v-col>
                      <v-col cols="6" sm="3" lg="4">
                        <div class="d-flex flex-column">
                          <span>
                            หมายเลขโทรศัพท์<span class="red--text">*</span>
                          </span>
                          <v-text-field
                            solo
                            hide-details="auto"
                            dense
                            v-model="items.mobile"
                            :readonly="view"
                          ></v-text-field>
                        </div>
                      </v-col>
                      <v-col cols="6" sm="3" lg="4">
                        <div class="d-flex flex-column">
                          <span>
                            Email (Email one)<span
                              class="red--text"
                              v-show="false"
                              >*</span
                            >
                          </span>
                          <v-text-field
                            solo
                            hide-details="auto"
                            dense
                            v-model="items.email"
                            :readonly="view"
                          ></v-text-field>
                        </div>
                      </v-col>

                      <v-col cols="6" sm="4" lg="4">
                        <div class="d-flex flex-column">
                          <span> HN </span>
                          <v-text-field
                            solo
                            hide-details="auto"
                            dense
                            v-model="items.HN"
                            :readonly="view"
                          ></v-text-field>
                        </div>
                      </v-col>
                    </v-row>
                  </v-expansion-panel-content>
                </v-expansion-panel>

                <v-expansion-panel :key="1">
                  <v-expansion-panel-header class="px-0">
                    <div class="d-flex align-center">
                      <span class="pr-5 text-007C92 w-500 font-18"
                        >ข้อมูลที่อยู่ตามทะเบียนราษฎร์</span
                      >
                      <v-divider></v-divider>
                    </div>
                  </v-expansion-panel-header>
                  <v-expansion-panel-content>
                    <v-row class="py-5">
                      <v-col cols="6" sm="4" lg="4">
                        <div class="d-flex flex-column">
                          <span>
                            บ้านเลขที่<span class="red--text" v-show="false"
                              >*</span
                            >
                          </span>
                          <v-text-field
                            solo
                            hide-details="auto"
                            dense
                            v-model="items.address.house_no"
                            :readonly="view"
                          ></v-text-field>
                        </div>
                        <!-- <div class="px-3"></div> -->
                      </v-col>
                      <v-col cols="6" sm="4" lg="4">
                        <div class="d-flex flex-column">
                          <span> หมู่ </span>
                          <v-text-field
                            solo
                            hide-details="auto"
                            v-model="items.address.moo_no"
                            dense
                            :readonly="view"
                          ></v-text-field>
                        </div>
                      </v-col>
                      <v-col cols="6" sm="4" lg="4">
                        <div class="d-flex flex-column">
                          <span> ถนน / ซอย </span>
                          <v-text-field
                            solo
                            hide-details="auto"
                            dense
                            v-model="items.address.soi"
                            :readonly="view"
                          ></v-text-field>
                        </div>
                      </v-col>
                      <v-col cols="6" sm="4" lg="4">
                        <div class="d-flex flex-column">
                          <span>
                            จังหวัด<span class="red--text" v-show="false"
                              >*</span
                            >
                          </span>
                          <v-autocomplete
                            :items="set_province"
                            item-value="province"
                            item-text="province"
                            @input="getAmphoe('template')"
                            :menu-props="{ bottom: true, offsetY: true }"
                            solo
                            dense
                            hide-details="auto"
                            placeholder="กรุณาเลือกจังหวัด"
                            v-model="items.address.province"
                            item-color="teal darken-2"
                            color="#00A99D"
                            :readonly="view"
                          >
                            <template slot="no-data">
                              <span class="pl-2">ไม่มีข้อมูลจังหวัด</span>
                            </template>
                          </v-autocomplete>
                        </div>
                      </v-col>
                      <v-col cols="6" sm="4" lg="4">
                        <div class="d-flex flex-column">
                          <span>
                            อำเภอ / เขต<span class="red--text" v-show="false"
                              >*</span
                            >
                          </span>
                          <v-autocomplete
                            :items="set_amphoe"
                            item-value="amphoe"
                            item-text="amphoe"
                            @input="getTambon('template')"
                            :menu-props="{ bottom: true, offsetY: true }"
                            solo
                            dense
                            hide-details="auto"
                            placeholder="กรุณาเลือกอำเภอ/เขต"
                            v-model="items.address.amphur"
                            item-color="teal darken-2"
                            color="#00A99D"
                            :readonly="view"
                          >
                            <template slot="no-data">
                              <span class="pl-2">กรุณาเลือกอำเภอ/เขต</span>
                            </template>
                          </v-autocomplete>
                        </div>
                      </v-col>
                      <v-col cols="6" sm="4" lg="4">
                        <div class="d-flex flex-column">
                          <span>
                            ตำบล / แขวง<span class="red--text" v-show="false"
                              >*</span
                            >
                          </span>
                          <!-- {{items.address.tambon}} -->
                          <v-autocomplete
                            :items="set_tambon"
                            item-value="tambon"
                            item-text="tambon"
                            @change="getPostal($event)"
                            :menu-props="{ bottom: true, offsetY: true }"
                            solo
                            dense
                            hide-details="auto"
                            placeholder="กรุณาเลือกตำบล/แขวง"
                            v-model="items.address.tambon"
                            item-color="teal darken-2"
                            color="#00A99D"
                            :readonly="view"
                          >
                            <template slot="no-data">
                              <span class="pl-2">กรุณาเลือกตำบล / แขวง</span>
                            </template>
                          </v-autocomplete>
                        </div>
                      </v-col>
                      <v-col cols="6" sm="4" lg="4">
                        <div class="d-flex flex-column">
                          <span>
                            รหัสไปรษณีย์<span class="red--text" v-show="false"
                              >*</span
                            >
                          </span>
                          <v-text-field
                            solo
                            hide-details="auto"
                            v-model="items.address.zipcode"
                            dense
                            :readonly="view"
                          ></v-text-field>
                        </div>
                      </v-col>
                    </v-row>
                  </v-expansion-panel-content>
                </v-expansion-panel>

                <v-expansion-panel :key="2">
                  <v-expansion-panel-header class="px-0">
                    <div class="d-flex align-center">
                      <span class="pr-5 text-007C92 w-500 font-18"
                        >ข้อมูลโรคประจำตัว</span
                      >
                      <v-divider></v-divider>
                    </div>
                  </v-expansion-panel-header>
                  <v-expansion-panel-content>
                    <v-row class="py-5">
                      <v-col cols="6" sm="4" lg="4">
                        <div class="d-flex flex-column">
                          <span>
                            โรคประจำตัว<span class="red--text" v-show="false"
                              >*</span
                            >
                          </span>
                          <v-text-field
                            solo
                            hide-details="true"
                            dense
                            v-model="items.congenitalDisease"
                            :readonly="view"
                          ></v-text-field>
                        </div>
                      </v-col>
                      <v-col cols="6" sm="4" lg="4">
                        <div class="d-flex flex-column">
                          <span>
                            แพ้ยา (ชื่อยา)<span class="red--text" v-show="false"
                              >*</span
                            >
                          </span>
                          <v-text-field
                            solo
                            hide-details="true"
                            dense
                            v-model="items.allergyDrug"
                            :readonly="view"
                          ></v-text-field>
                        </div>
                      </v-col>
                      <v-col cols="6" sm="4" lg="4">
                        <div class="d-flex flex-column">
                          <span> อาการแพ้ยา </span>
                          <v-text-field
                            solo
                            hide-details="true"
                            dense
                            v-model="items.allergyDrugDetail"
                            :readonly="view"
                          ></v-text-field>
                        </div>
                      </v-col>
                    </v-row>
                  </v-expansion-panel-content>
                </v-expansion-panel>
              </v-expansion-panels>
              <v-card-actions class="justify-center">
                <v-col cols="6" class="pr-2 pl-0"
                  ><v-btn block outlined color="#00a99d" @click="dialog = false"
                    >ยกเลิก</v-btn
                  ></v-col
                >
                <v-col cols="6" class="pl-2 pr-0"
                  ><v-btn
                    block
                    dark
                    depressed
                    color="#00a99d"
                    :loading="btn_loading"
                    type="submit"
                    >ยืนยัน</v-btn
                  ></v-col
                >
              </v-card-actions></v-form
            >
            <!-- <v-btn @click="test">test</v-btn> -->
            <!-- <pre>{{ items }}</pre> -->
          </v-card-text>
        </v-card>
      </v-dialog>
      <!-- <HistoryCalling ref="HistoryCalling" /> -->
      <HistoryDianotic ref="HistoryDianotic" />
      <FindByCid ref="FindByCid" />
      <DashboardEditNurseDialog
        ref="dashboardEditNurseDialog"
        @close="getPatitentList"
      />
    </v-container>
  </div>
</template>
<script>
import moment from "moment";
import { mapMutations, mapGetters } from "vuex";
import functioncryto from "@/services/encrypt.js";
// import HistoryCalling from "@/components/dialog/HistoryCalling.vue";
import HistoryDianotic from "@/components/dialog/HistoryDianotic.vue";
import HeaderUser from "@/components/dialog/HeaderUser.vue";
import FindByCid from "@/components/dialog/FindByCid.vue";
import { Pagination } from "@/components/pagination";
import DashboardEditNurseDialog from "../components/DashboardEditNurseDialog.vue";

export default {
  components: {
    // HistoryCalling,
    HistoryDianotic,
    HeaderUser,
    FindByCid,
    Pagination,
    DashboardEditNurseDialog,
  },
  data: () => ({
    set_province: [],
    set_amphoe: [],
    set_tambon: [],
    search: "",
    dialog: false,
    panel: [0, 1],
    view: false,
    isEmpty: [(v) => !!v || "กรุณากรอกข้อมูล"],
    isEmptySelect: [(v) => !!v || "กรุณาเลือกข้อมูล"],
    btn_loading: false,
    editedIndex: -1,
    headers: [
      {
        text: "ลำดับ",
        value: "no",
        sortable: false,
        align: "center",
        width: "10%",
      },
      {
        text: "ชื่อผู้รับบริการ",
        align: "left",
        sortable: false,
        value: "name",
      },
      {
        text: "เพศ",
        align: "left",
        sortable: false,
        value: "gender",
      },
      {
        text: "อายุ",
        align: "left",
        sortable: false,
        value: "old",
      },
      {
        text: "ข้อมูลติดต่อ",
        align: "left",
        sortable: false,
        value: "phone",
      },
      {
        text: "ผลตรวจร่างกาย",
        value: "actions",
        sortable: false,
        align: "center",
        width: "15%",
      },
    ],
    patientList: [],
    items: {
      age: "",
      mobile: "",
      id_card_type: "ID_CARD",
      id_card_num: "",
      address: {
        house_no: "",
        moo_no: "",
        soi: "",
        province: "",
        amphur: "",
        tambon: "",
        zipcode: "",
      },
      email: "",
      account_title_th: "",
      account_title_eng: "",
      first_name_eng: "",
      first_name_th: "",
      last_name_eng: "",
      last_name_th: "",
      birth_date: "",
      gender: "",
      blood: "",
      HN: "",
      hos_code: "",
      _id: "",
    },
    titleItems: ["เด็กหญิง", "เด็กชาย", "นางสาว", "นาย", "นาง"],
    itemType: [
      { value: "ID_CARD", text: "บัตรประชาชน" },
      { value: "PASSPORT", text: "PASSPORT" },
    ],
    menubirth_date: false,
    yearmax: "",
    total: 0,
    page: 1,
    object_id: "",
    edit: false,
    biz_id: ""
  }),
  async created() {
    await this.getProvince();
    await this.getHoscode();
    await this.getPatitentList();
    this.biz_id = sessionStorage.biz_id;
    var now_date = new Date();
    this.yearmax = now_date.getFullYear() - 7 + "-" + 12 + "-" + 31;
  },
  computed: {
    ...mapGetters(["bizId"]),
    almost_mobile() {
      if (this.$vuetify.breakpoint.width < 450) {
        return true;
      } else {
        return false;
      }
    },
    formTitle() {
      return this.editedIndex === -1
        ? "เพิ่มรายชื่อผู้ป่วย"
        : "แก้ไขรายชื่อผู้ป่วย";
    },
    isFormDisabled() {
      return this.formTitle === "แก้ไขรายชื่อผู้ป่วย";
    },
    formatBirthDate() {
      if (this.items.birth_date === undefined || this.items.birth_date === "")
        return "";
      return moment(this.items.birth_date)
        .add(543, "year")
        .format("DD/MM/YYYY");
    },
  },
  watch: {
    menubirth_date(val) {
      val &&
        this.$nextTick(() => (this.$refs.picker.internalActivePicker = "YEAR"));
    },
    search(val) {
      if (val == "" || val == null) {
        this.getPatitentList();
      } else {
        this.searchData();
      }
    },
  },
  methods: {
    async getProvince() {
      try {
        this.items.address.zipcode = "";
        await this.axios
          .get(`${process.env.VUE_APP_BACKEND_URL}/province`)
          .then((res) => {
            if (res.status == 200) {
              this.set_province = res.data.data;
            }
          });
      } catch (err) {
        console.log(err);
        // this.$swal({
        //   title:
        //     "<span style='color: black;font-size: 18px;font-family: Sarabun, sans-serif;'>เกิดข้อผิดผลาด</span>",
        //   icon: "error",
        //   showCloseButton: false,
        //   showConfirmButton: false,
        //   background: "white",
        //   timer: 3000,
        // });
      }
    },
    async getAmphoe(from) {
      try {
        this.items.address.zipcode = "";
        await this.axios
          .get(
            `${process.env.VUE_APP_BACKEND_URL}/province/amphoe/${this.items.address.province}`
          )
          .then((res) => {
            if (res.status == 200) {
              if (this.items.address.province == "ฉะเชิงเทรา") {
                var arr = res.data.filter((ele) => {
                  return ele.amphoe !== "บางประกง";
                });
                this.set_amphoe = arr;
              } else {
                this.set_amphoe = res.data.data;
              }

              if (from == "template") {
                this.items.address.amphur = "";
                this.items.address.tambon = "";
              } else if (from == "api") {
                if (this.items.address.amphur) {
                  this.getTambon("api");
                } else {
                  this.items.address.tambon = "";
                }
              }
            }
          });
      } catch (err) {
        console.log(err);
        this.$swal({
          title:
            "<span style='color: black;font-size: 18px;font-family: Sarabun, sans-serif;'>เกิดข้อผิดผลาด</span>",
          icon: "error",
          showCloseButton: false,
          showConfirmButton: false,
          background: "white",
          timer: 3000,
        });
      }
    },
    async getTambon(from) {
      try {
        this.items.address.zipcode = "";
        await this.axios
          .get(
            `${process.env.VUE_APP_BACKEND_URL}/province/amphoe/tambon/${this.items.address.province}/${this.items.address.amphur}`
          )
          .then(async (res) => {
            if (res.status == 200) {
              if (from == "template") {
                if (this.items.address.amphur == "เมืองหนองคาย") {
                  for (let i of res.data) {
                    if (i.tambon === "สองห้อง") {
                      i.tambon = "โพนสว่าง";
                    }
                  }
                  this.set_tambon = res.data.data;
                } else {
                  this.set_tambon = res.data.data;
                }
              } else if (from == "api") {
                if (this.items.address.amphur == "เมืองหนองคาย") {
                  for (let i of res.data) {
                    if (i.tambon === "สองห้อง") {
                      i.tambon = "โพนสว่าง";
                    }
                  }
                  this.set_tambon = res.data.data;
                } else {
                  this.set_tambon = res.data.data;
                }
                await this.getPostal(this.items.address.tambon);
              }
            }
          });
      } catch (err) {
        console.log(err);
        this.$swal({
          title:
            "<span style='color: black;font-size: 18px;font-family: Sarabun, sans-serif;'>เกิดข้อผิดผลาด</span>",
          icon: "error",
          showCloseButton: false,
          showConfirmButton: false,
          background: "white",
          timer: 3000,
        });
      }
    },
    getPostal(e) {
      var postal = this.set_tambon.find((ele) => {
        return ele.tambon === e;
      });

      if (postal !== undefined) {
        this.items.address.zipcode = postal.zipcode;
      } else {
        this.items.address.zipcode = "";
      }
    },
    dashboardEditNurseDialog() {
      this.$refs.dashboardEditNurseDialog.openDialog();
    },
    ...mapMutations(["setDetailConference", "setDetailPhysicalExam"]),
    addPatient() {
      this.dialog = true;
    },
    openConference(item) {
      this.setDetailConference(item);
      this.$router.push({ name: "ConferenceDetail" });
    },
    genderChange() {
      if (this.items.gender === "ชาย") {
        this.items.account_title_th = "เด็กชาย";
        this.items.account_title_eng = "Mr.";
        this.titleItems = ["เด็กชาย", "นาย"];
      }
      if (this.items.gender === "หญิง") {
        this.items.account_title_th = "เด็กหญิง";
        this.items.account_title_eng = "Miss";
        this.titleItems = ["เด็กหญิง", "นางสาว", "นาง"];
      }
    },
    close() {
      this.dialog = false;
      (this.items = {
        age: "",
        mobile: "",
        id_card_type: "ID_CARD",
        id_card_num: "",
        address: {
          house_no: "",
          moo_no: "",
          soi: "",
          province: "",
          amphur: "",
          tambon: "",
          zipcode: "",
        },
        email: "",
        account_title_th: "",
        account_title_eng: "",
        first_name_eng: "",
        first_name_th: "",
        last_name_eng: "",
        last_name_th: "",
        birth_date: "",
        gender: "",
        blood: "",
        HN: "",
        hos_code: "",
        allergyDrug: "",
        allergyDrugDetail: "",
        congenitalDisease: "",
        findHis: "",
      }),
        (this.editedIndex = -1);
      this.edit = false;
    },
    save() {
      if (this.editedIndex !== -1) {
        this.clickConfirmed_edit();
      } else {
        this.clickConfirmed();
      }
    },
    clickConfirmed() {
      if (this.$refs.form.validate()) {
        this.btn_loading = true;
        let cid_value = functioncryto.encrypt(this.items.id_card_num);
        let data = {
          // oneid: sessionStorage.oneId ? sessionStorage.oneId : null,
          one_id: null,
          // accountId: sessionStorage.account_id ? sessionStorage.account_id : null,
          account_id: null,
          account_title_th: this.items.account_title_th,
          account_title_eng: this.items.account_title_eng,
          cid: cid_value,
          first_name_eng: this.items.first_name_eng,
          first_name_th: this.items.first_name_th,
          last_name_eng: this.items.last_name_eng,
          last_name_th: this.items.last_name_th,
          mobile: this.items.mobile,
          birth_date: this.items.birth_date,
          biz_id: sessionStorage.biz_id ? sessionStorage.biz_id : null,
          id_card_type: this.items.id_card_type,
          id_card_num: this.items.id_card_num, //
          hospital_code: this.findHis,
          hos_code: this.findHis,
          email: this.items.email, //
          address: [
            {
              houseNo: this.items.address.house_no,
              moo: this.items.address.moo_no,
              soi: this.items.address.soi,
              amphur: this.items.address.amphur,
              tambon: this.items.address.tambon,
              province: this.items.address.province,
              zipcode: this.items.address.zipcode,
              official: true,
              default: true,
            },
          ],
          blood: this.items.blood,
          HN: this.items.HN,
          allergyDrug: this.items.allergyDrug, //
          allergyDrugDetail: this.items.allergyDrugDetail, //
          congenitalDisease: this.items.congenitalDisease, //
        };
        this.axios
          .post(`${process.env.VUE_APP_BACKEND_URL}/v1/user-qr`, data)
          .then((res) => {
            if (res.status == 200 && res.data) {
              this.$swal.fire({
                icon: "success",
                title: "สำเร็จ",
                timer: 3000,
                showConfirmButton: false,
                showCloseButton: false,
              });
              this.dialog = false;
              this.btn_loading = false;
              this.$emit("addPatient", "add");
              this.getPatitentList();
              this.close();
            }
          });
      }
    },
    async clickConfirmed_edit() {
      var payload = {
        account_title_th: this.items.account_title_th,
        account_title_eng: this.items.account_title_eng,
        first_name_eng: this.items.first_name_eng,
        first_name_th: this.items.first_name_th,
        last_name_eng: this.items.last_name_eng,
        last_name_th: this.items.last_name_th,
        mobile: this.items.mobile,
        email: this.items.email,
        birth_date: this.items.birth_date,
        blood: this.items.blood,
        HN: this.items.HN,
        houseNo: this.items.address.house_no,
        moo: this.items.address.moo_no,
        soi: this.items.address.soi,
        amphur: this.items.address.amphur,
        tambon: this.items.address.tambon,
        province: this.items.address.province,
        zipcode: this.items.address.zipcode,
        allergyDrug: this.items.allergyDrug,
        allergyDrugDetail: this.items.allergyDrugDetail,
        congenitalDisease: this.items.congenitalDisease,
      };
      await this.axios
        .put(
          `${process.env.VUE_APP_BACKEND_URL}/v1/patients/${this.object_id}`,
          payload
        )
        .then((response) => {
          if (response.data.result === "success") {
            this.$swal.fire({
              icon: "success",
              title: "แก้ไขข้อมูลสำเร็จ",
              showConfirmButton: false,
              timer: 1000,
            });
            this.getPatitentList();
            this.close();
          } else if (response.data.result === "already exists") {
            this.$swal.fire(
              "ข้อมูลนี้ถูกใช้ไปแล้ว",
              "กรุณาลองใหม่อีกครั้ง",
              "warning"
            );
          } else {
            this.$swal.fire("ผิดพลาด", "กรุณาลองใหม่อีกครั้ง", "error");
          }
        });
    },
    async getHoscode() {
      try {
        const { data: { data } = {} } = await this.axios.get(
          `https://qr-tele.manageai.co.th/api/v1/bizid/hospital/getall?is_deleted=0`,
          {
            headers: {
              Authorization:
                "Bearer eyJhbGciOiJSUzI1NiIsInR5cCI6IkpXVCJ9.eyJleHAiOjE3MzUzNzE4NzEsImlhdCI6MTcwNDI2Nzg3MSwibmJmIjoxNzA0MjY3ODcxLCJyZWYiOjAsInN1YiI6ImQ4ZDZjZDlhLWNmZjktNDI4Yi05NGFlLWY1ZGZiMWU2OTRkNiJ9.dAsuJepoiD703rSIlV0LeJzoMerdNfuShq3ZFFXX1auJWtWZsAZ80vgG6oP5qdix3n90lHoxn-TzrK4l-7qWpg",
            },
          }
        );
        const ov_code = data.find(
          (element) => element.business_id == sessionStorage.biz_id
        );
        if (ov_code) {
          this.findHis = ov_code.hospital_code;
        } else {
          this.findHis = "";
        }
        console.log("🚀 ~ file: Dashboard.vue:1193 ~ getHoscode ~ data:",data.find(
          (element) => element.business_id == sessionStorage.biz_id
        ));
      } catch (error) {
        console.error();
      }
    },
    titleChange() {
      if (
        this.items.account_title_th === "นาย" ||
        this.items.account_title_th === "เด็กชาย"
      ) {
        this.items.gender = "ชาย";
        this.titleItems = ["เด็กชาย", "นาย"];
      }
      if (
        this.items.account_title_th === "นาง" ||
        this.items.account_title_th === "นางสาว" ||
        this.items.account_title_th === "เด็กหญิง"
      ) {
        this.items.gender = "หญิง";
        this.titleItems = ["เด็กหญิง", "นางสาว", "นาง"];
      }
    },
    displayIdCard(idcard) {
      if (idcard === "" || idcard === undefined) return "หมายเลขบัตรประชาชน";
      if (idcard === "PASSPORT") return "PASSPORT";
      return "หมายเลขบัตรประชาชน";
    },
    calculateAge(date) {
      if (date) {
        this.menubirth_date = false;
        this.$refs.birth_date.save(date);
        const y = Math.floor(moment.duration(moment().diff(date)).asYears());
        this.items.age = y.toString();
      }
    },
    cancel_birth() {
      this.menubirth_date = false;
      this.$refs.birth_date.save("");
      this.items.age = "";
    },
    async getPatitentList() {
      const params = new URLSearchParams();
      params.append("page", this.page || 1);
      params.append("limit", 10);
      params.append("biz_id", sessionStorage.biz_id);
      await this.axios
        .get(`${process.env.VUE_APP_BACKEND_URL}/v1/patients/all?${params}`)
        .then((res) => {
          if (res.data) {
            // res.data.data.forEach((element) => {
            //   element.fullname = `${
            //     element.account_title_th ? element.account_title_th : ""
            //   }${element.first_name_th ? element.first_name_th : ""} ${
            //     element.last_name_th ? element.last_name_th : ""
            //   }`;
            // });
            if (res.data.data[0]) {
              const { data: searchData, metadata } = res.data.data[0];
              console.log(
                "🚀 ~ file: DashboardNurse.vue:1083 ~ .then ~ metadata:",
                metadata
              );

              if (metadata.length == 0) {
                this.total = 0;
                this.patientList = [];
              } else {
                const { total } = metadata[0];
                this.total = total;
                this.patientList = searchData;
                // console.log(total);
                // console.log(searchData);
              }
            }
            // this.patientList = Object.assign([], res.data.data);
            // console.log("getPatitentList", this.patientList);
          }
        });
    },
    async searchData() {
      const params = new URLSearchParams();
      params.append("page", this.page || 1);
      params.append("limit", 10);
      params.append("biz_id", sessionStorage.biz_id);
      params.append("search", this.search);
      await this.axios
        .get(`${process.env.VUE_APP_BACKEND_URL}/v1/patients/search_record?${params}`)
        .then((res) => {
          if (res.data) {
            let searchPatient = res.data.data[0].data;
            searchPatient.forEach((element) => {
              element.fullname = `${
                element.account_title_th ? element.account_title_th : ""
              }${element.first_name_th ? element.first_name_th : ""} ${
                element.last_name_th ? element.last_name_th : ""
              }`;
            });
            this.patientList = Object.assign([], searchPatient);
            // console.log("searchData", this.patientList);
          }
        });
    },
    test() {
      let cid_value = functioncryto.encrypt(this.items.id_card_num);
      console.log(cid_value);
    },

    async emrCall(item) {
      // this.setDetailPhysicalExam(item)
      const { one_id, account_title_th, first_name_th, last_name_th } = item;
      const params = {
        send_by: {
          one_id: sessionStorage.account_id,
          role: sessionStorage.role_name,
        },
        biz_id: sessionStorage.biz_id,
        receiver_oneid: one_id,
        sender_oneid: sessionStorage.account_id,
        topic_name: "Emr-call",
        mode: "oneid",
        secret_key: "80135d71877e4afa31ad52043fd46b09ba26eb68",
        record: true,
        redirect_url: "https://uat-amctelemedicine.one.th/management/thank-you",
        ref1: `BIZID_${sessionStorage.biz_id}`,
        ref2:"teleconsult_Emr",
        ref3:`${first_name_th} ${last_name_th}`
      };
      try {
        const { data: { result, data } = {} } = await this.axios.post(
          `${process.env.VUE_APP_BACKEND_URL}/v1/conferences/create-room-emr`,
          params
        );
        if (result == "success") {
          this.setDetailConference({
            ...data,
            patient_name: `${account_title_th} ${first_name_th} ${last_name_th}`,
          });
          this.$router.push({ name: "ConferenceDetail" });
        }
      } catch (error) {
        console.error();
      }
      // this.$router.push({ name: "ConferenceDetail" });
    },
    healthOpen(item) {
      const { cid, one_id, first_name_th, last_name_th, birth_date } = item;
      console.log(item);
      const payload = {
        cid,
        one_id: one_id,
        year: moment().format("YYYY"),
        bizId: sessionStorage.biz_id,
        checkDate: moment().format("YYYY-MM-DD"),
        queue: "",
        general: {
          general: {
            weight: "",
            height: "",
            bmi: "",
            comment: "",
            congenitalDisease: "",
            allergicHistory: "",
            smokingHistory: "",
            historyOfDrinking: "",
            bp: "",
            pulse: "",
            lastMenstrualPeriod: "",
            summaryBpPuls: "",
            summaryPhysical: "",
            chestXray: "",
            ekg: "",
            visionTest: "",
          },
          occupationVisionTest: {
            visionTests_R: "",
            visionTests_L: "",
            visionTests_3D: "",
            visionTestsSeparate: "",
            visionTestsEyeMuscles: "",
            visionTestsField: "",
          },
          audioGraphy: {
            audiometry_R: ["", "", "", "", "", "", ""],
            audiometry_L: ["", "", "", "", "", "", ""],
            audiometry: "",
          },
          lungFunctionTest: {
            fev1: "",
            fvc: "",
            fev1_fvc: "",
            resutLungTest: "",
            lungFunctionTest: "",
          },
        },
        treatmentEtc: {
          other: [
            {
              checklist: "",
              results: "",
              normal: "",
              summary: "ปกติ",
            },
            {
              checklist: "",
              results: "",
              normal: "",
              summary: "ปกติ",
            },
          ],
          performance: {
            armAndHand: {
              results: "",
              summary: "ปกติ",
            },
            backAndlegs: {
              results: "",
              summary: "ปกติ",
            },
          },
          stoolExam: "",
        },
        bloodCount: {
          completeBloodCount: {
            hb: "",
            hct: "",
            rbc: "",
            wbc: "",
            neutrophil: "",
            lymphocyte: "",
            monocyte: "",
            eosinophi: "",
            basophil: "",
            platelet: "",
            mcv: "",
            mch: "",
            mchc: "",
            rbcMorphology: "",
            summaryBloodCount: "",
          },
        },
        urineResults: {
          urinalysis: {
            colors: "",
            appearance: "",
          },
          urineStrip: {
            specificGravity: {
              result: "",
            },
            ph: {
              result: "",
            },
            glucose: {
              result: "",
            },
            protein: {
              result: "",
            },
            blood: {
              result: "",
            },
          },
          urineMicroscopy: {
            wbc: {
              result: "",
            },
            rbc: {
              result: "",
            },
            epithelialCell: {
              result: "",
            },
            bacteria: {
              result: "",
            },
          },
        },
        labResult: {
          liverFunction: {
            totalProtein: {
              result: "",
              summary: "ปกติ",
            },
            albumin: {
              result: "",
              summary: "ปกติ",
            },
            glubulin: {
              result: "",
              summary: "ปกติ",
            },
            totalBilirubin: {
              result: "",
              summary: "ปกติ",
            },
            directBilirubin: {
              result: "",
              summary: "ปกติ",
            },
            sgot: {
              result: "",
              summary: "ปกติ",
            },
            sgpt: {
              result: "",
              summary: "ปกติ",
            },
            alkPhosphatase: {
              result: "",
              summary: "ปกติ",
            },
          },
          kidneyFunction: {
            bun: {
              result: "",
              summary: "ปกติ",
            },
            creatinine: {
              result: "",
              summary: "ปกติ",
            },
          },
          uricAcidFunction: {
            uricAcid: {
              result: "",
              summary: "ปกติ",
            },
          },
          bloodGroupDetection: {
            bloodGroup: {
              result: "",
              summary: "ปกติ",
            },
          },
          hepatitisB: {
            HBsAg: {
              result: "",
              summary: "ไม่ปกติ",
            },
            antiHBs: {
              result: "",
              summary: "ปกติ",
            },
          },
          urine: {
            amphetamine: {
              result: "",
              summary: "ปกติ",
            },
          },
        },
        laboratory: {
          bloodSugarLevel: {
            fbs: {
              result: "",
              summary: "ปกติ",
            },
          },
          bloodLipidLevel: {
            cholesterol: {
              result: "",
              summary: "ปกติ",
            },
            triglyceride: {
              result: "",
              summary: "ปกติ",
            },
            HDLCholesterol: {
              result: "",
              summary: "ปกติ",
            },
            LDLCholesterol: {
              result: "",
              summary: "ปกติ",
            },
          },
        },
        summary: [
          {
            general_status: "",
          },
          {
            blood_status: "",
          },
          {
            urine_status: "",
          },
          {
            x_ray_status: "",
          },
          {
            vision_status: "",
          },
          {
            pressure_status: "",
          },
          {
            b_virus_status: "",
          },
          {
            hdl_status: "",
          },
          {
            ldl_status: "",
          },
        ],
        file_id: "",
        full_name_th: `${first_name_th} ${last_name_th}`,
        full_name_eng: null,
        search_name: `${first_name_th} ${last_name_th}`,
        date: moment().format("YYYY"),
        fullname: "",
        birth_date: birth_date,
      };
      console.log(payload);
      // const {} = item;
      // const data =

      this.setDetailPhysicalExam(payload);
      this.$router.push({ name: "PhysicalExam" });

      // this.$router.push({ name: "PhysicalExam" });
    },
    dianoticOpen(item) {
      this.$refs.HistoryDianotic.open(item);
      // this.$router.push({ name: "PhysicalExam" });3
    },
    patientOpen(item) {
      let num = item.address.length - 1;
      this.editedIndex = item.drug_id;
      this.object_id = item._id;
      this.dialog = true;
      this.$nextTick(() => {
        this.$refs.HeaderUser.open(item);
      });
      this.items.address = item.address[0];
      this.getAmphoe("api");
      this.items = {
        // oneid: sessionStorage.oneId ? sessionStorage.oneId : null,
        one_id: null,
        // accountId: sessionStorage.account_id ? sessionStorage.account_id : null,
        account_id: null,
        account_title_th: item.account_title_th,
        account_title_eng: item.account_title_eng,
        cid: item.cid,
        first_name_eng: item.first_name_eng,
        first_name_th: item.first_name_th,
        last_name_eng: item.last_name_eng,
        last_name_th: item.last_name_th,
        mobile: item.mobile,
        birth_date: item.birth_date,
        biz_id: item.biz_id,
        email: item.email,
        address: item.address[num],
        id_card_num: item.id_card_num,
        id_card_type: item.id_card_type,
        hospital_code: item.hos_code,
        hos_code: item.hos_code,
        blood: item.blood,
        HN: item.HN,
        allergyDrug: item.allergyDrug, //
        allergyDrugDetail: item.allergyDrugDetail, //
        congenitalDisease: item.congenitalDisease, //
      };
      this.items.gender = this.displayItem(item, "gender");
      this.items.age = this.displayItem(item, "old");
      this.items.address.house_no = item.address[num].houseNo;
      this.items.address.moo_no = item.address[num].moo;
      this.items.address.amphur = item.address[num].amphur;
      this.items.id_card_num = this.displayCID(item.cid);
    },
    displayCID(cid) {
      if (cid) {
        const maskedDigits = "X".repeat(6);
        const visibleDigits = functioncryto.decrypt(cid).substring(6);
        return maskedDigits + visibleDigits;
      } else return "";
    },
    findCIDOpen(item) {
      this.$refs.FindByCid.open(item);
      // this.$router.push({ name: "PhysicalExam" });
    },
    displayItem(item, type) {
      const { account_title_th, birth_date, mobile } = item;

      switch (type) {
        case "gender":
          if (["เด็กชาย", "นาย"].includes(account_title_th)) return "ชาย";
          if (["เด็กหญิง", "นางสาว", "นาง"].includes(account_title_th))
            return "หญิง";
          break;

        case "old":
          if (birth_date) {
            const y = Math.floor(
              moment.duration(moment().diff(birth_date)).asYears()
            );
            return y;
          }
          break;

        case "phone":
          if (mobile) {
            return mobile;
          }
          break;
      }
    },
    changePage(e) {
      this.page = e;
      this.getPatitentList();
    },
  },
};
</script>
<style scoped>
.stycard {
  /* bg */
  position: absolute;
  /* white */
  background: #ffffff;
  border-radius: 80px 0px 0px 0px;
}
.card-search {
  background: #ceefed;
  border-radius: 20px 5px;
}
.table-viewdoc th {
  background: #ceefed !important;
  color: #00a99d !important;
}
.card-medium {
  background: #ceefed;
  border-radius: 20px 5px;
  box-shadow: none !important;
}
.card-medium-cancel {
  /* background: #ceefed; */
  border-radius: 20px 5px;
  box-shadow: none !important;
}
.card-medium-download {
  /* background: #ceefed; */
  border-radius: 20px 5px;
  box-shadow: none !important;
}
.theme-back {
  background-color: #00a99d;
  color: #ffffff;
}

.icon-dark {
  background: #ceefed;
  border-radius: 16px 5px;
  padding: 5px;
}
.icon-light {
  background: #00a99d;
  border-radius: 16px 5px;
  padding: 5px;
}

::v-deep .v-list-item .v-list-item__title,
.v-list-item .v-list-item__subtitle {
  line-height: 1.5rem !important;
}

::v-deep .v-select__selections {
  line-height: 25px;
}

::v-deep .v-data-table-header {
  background: #ceefed;
}

::v-deep .v-data-table-header.v-data-table-header-mobile {
  display: none;
}

::v-deep .v-data-table > .v-data-table__wrapper > table > tbody {
  display: table-row-group;
  vertical-align: middle;
  border-color: inherit;
}

::v-deep .v-data-table > .v-data-table__wrapper > table > thead > tr > th {
  color: #00a99d;
  font-weight: 700;
  font-size: 14px !important;
}

::v-deep
  .v-data-table
  > .v-data-table__wrapper
  .v-data-table__mobile-table-row {
  display: block !important;
  background-color: white;
}

::v-deep .v-data-table > .v-data-table__wrapper > table {
  border-spacing: 0 15px;
  background: #fff;
  /* border-collapse: separate; */
  /* border-bottom: none; */
}

::v-deep .v-data-table > .v-data-table__wrapper > table > tbody > tr {
  background: #ebf7f7;
}

::v-deep
  .theme--light.v-data-table
  > .v-data-table__wrapper
  > table
  > thead
  > tr:last-child
  > th {
  border-bottom: none;
}

::v-deep
  .theme--light.v-data-table
  > .v-data-table__wrapper
  > table
  > thead
  > tr
  > th {
  border-bottom: none;
}

::v-deep
  .theme--light.v-data-table
  > .v-data-table__wrapper
  > table
  > tbody
  > tr:not(:last-child)
  > td:not(.v-data-table__mobile-row),
.theme--light.v-data-table
  > .v-data-table__wrapper
  > table
  > tbody
  > tr:not(:last-child)
  > th:not(.v-data-table__mobile-row) {
  border-bottom: none;
}

.theme--light.v-data-table
  .v-data-table-header
  th.sortable
  .v-data-table-header__icon {
  display: none;
}

::v-deep .v-data-table-header__icon {
  display: none;
}

::v-deep
  .v-data-table
  > .v-data-table__wrapper
  .v-data-table__mobile-table-row {
  display: block !important;
  background-color: white;
}

::v-deep .v-data-table-header.v-data-table-header-mobile {
  display: none;
}

::v-deep .v-data-table-header__icon {
  display: none;
}

::v-deep
  .theme--light.v-data-table
  > .v-data-table__wrapper
  > table
  > tbody
  > tr:hover:not(.v-data-table__expanded__content):not(
    .v-data-table__empty-wrapper
  ) {
  background: #ceefed !important;
}
</style>
